import React from 'react'

import CollegeTypeahead from '@scoir/components-typeahead/dist/CollegeTypeahead'
import { map } from 'lodash'
import PropTypes from 'prop-types'

import api from 'common/api'

const MAX_RESULTS = 50
const API_PAGE_SIZE = MAX_RESULTS + 1

// const getCollegeSearchUrl = (name, pageIdx) => `/api/university/search/name/${name}?limit=${API_PAGE_SIZE}&from=${(pageIdx - 1) * API_PAGE_SIZE}&exclude2year=false`
const getCollegeSearchUrl = (name, pageIdx) =>
  `/api/search/college/${name}?size=${API_PAGE_SIZE}&from=${(pageIdx - 1) * API_PAGE_SIZE}`

class CounselorCollegeTypeahead extends React.Component {
  static propTypes = {
    allowNew: PropTypes.bool,
    clearOnSelect: PropTypes.bool,
    selected: PropTypes.array,
    onChange: PropTypes.func.isRequired,
    placeholder: PropTypes.string,
    align: CollegeTypeahead.propTypes.align,
  }
  static defaultProps = {
    selected: [],
    placeholder: 'Type a college name',
    align: 'left',
  }
  searchColleges(name, pageIdx) {
    return api.get(getCollegeSearchUrl(name, pageIdx)).then((options) =>
      map(options, (option) => ({
        SchoolName: option.name,
        City: option.tokens[2],
        State: option.tokens[3],
        Scid: parseInt(option.tokens[0]),
      })),
    )
  }
  render() {
    const { allowNew, clearOnSelect, onChange, ...rest } = this.props
    return (
      <CollegeTypeahead
        {...rest}
        className="college-typeahead"
        allowNew={allowNew}
        clearOnSelect={clearOnSelect}
        placeholder={this.props.placeholder}
        maxResults={allowNew ? API_PAGE_SIZE : MAX_RESULTS}
        onSearch={(name) => this.searchColleges(name, 1)}
        onPaginate={(name, page) => this.searchColleges(name, page)}
        onSelect={onChange}
      />
    )
  }
}
CounselorCollegeTypeahead.DismissableItem = CollegeTypeahead.DismissableItem
export default CounselorCollegeTypeahead
